import { DateTime } from 'luxon'

export const NOW = DateTime.now()
export const TODAY = DateTime.now().startOf('day')
export const TOMORROW = TODAY.plus({ days: 1 })
export const ZONED_TODAY = (timezone: string) => DateTime.now().setZone(timezone).startOf('day')
export const ONE_DAY_AGO = TODAY.minus({ days: 1 })
export const ONE_YEAR_AGO = TODAY.minus({ years: 1 })
export const ONE_MONTH_AGO = TODAY.minus({ months: 1 })
